import {Component, Inject, OnInit} from '@angular/core';
import {LeftpanelComponent, LoaderWithProgressComponent} from '../../../leftpanel/leftpanel.component';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';
import {MAT_DIALOG_DATA, MatSnackBar} from '@angular/material';
import {ConfService} from '../../../conf.service';
import {ConnecttocrudService} from '../../../connecttocrud.service';
import {FormControl} from '@angular/forms';
import {environment} from '../../../../environments/environment';

@Component({
  selector: 'app-add-user-group-component',
  templateUrl: './add-user-group-component.component.html',
  styleUrls: ['./add-user-group-component.component.scss']
})
export class AddUserGroupComponentComponent implements OnInit {

  constructor(
      public platform: LeftpanelComponent,
      public dialogRef: MatDialogRef<AddUserGroupComponentComponent>,
      @Inject(MAT_DIALOG_DATA) public data: any,
      public dialog: MatDialog,
      private confPost: ConfService,
      private _snackBar: MatSnackBar,
      public _service: ConnecttocrudService
  ) {}

  groupName: string;
  description: string;
  selectedUserlist: any;
  usersList = [];
  selectedRolelist: any;
  rolesList: any;
  selectedEnvironments: any;
  environmentList: any;
  partnerName: string;
  userGroups: any;
  selectedEnvironmentsObjs = [];

  getRoles() {
    this._service.getItemswithParameter('v1', environment.accessPartner, environment.accessPartner, 'roles', 'partner.in=services&&type.in=platform').subscribe(data => {
      if (data) {
        this.rolesList = data;
        this.rolesList = this.rolesList.filter(value => value['role'] !== 'Platform Admin' && value['role'] !== 'Super Admin' && !value['role'].includes('=>'));
      }
    });
  }

  getUsers() {
    const temp = this.partnerName.split('-');
    this._service.getItemswithParameter('v1', environment.accessPartner, environment.accessPartner, 'users', 'partner.in=' + temp[temp.length - 1]).subscribe(res => {
      if (res) {
        let users:any;
        users = res;
        for (const user of users['users']) {
          const shortname = user['user'].split('-');
          if (shortname[0] !== 'admin' && user['status']) {
            this.usersList.push(user);
          }
        }
      }
    });
  }

  getGroups() {
    const shortName = this.partnerName.split('-');
    this._service.getItemswithParameter('v1', environment.accessPartner, environment.accessPartner, 'usergroups', 'partners.in=' + shortName[shortName.length - 1]).subscribe(res => {
      if (res) {
        this.userGroups = res;
      }
    });
  }

  closeDialog() {
    this.dialogRef.close();
  }

  async createGroup() {
    const loaderDialog = this.dialog.open(LoaderWithProgressComponent, {
      maxWidth: '95vw',
      maxHeight: '60vh',
    });
    if ((this.userGroups.filter(element => element['name'] === this.groupName)).length === 0) {
      const shortName = this.partnerName.split('-');

      let selectedRoles = this.selectedRolelist.map(role => role['id']);
      for (let e of this.selectedEnvironments) {
        const roleDetails = {
          'role': e + '=>' + e + '=>' + this.groupName,
          'permission_groups': [],
          'permissions': [],
          'roles': [],
          'exclusions': [],
          'partner': e,
          'account': e,
          'type': 'account'
        };
        const roleId = await this.createRoleForEachEnvironment(roleDetails);
        if(roleId !== 'failed'){
          selectedRoles.push(roleId);
        }
        this.selectedEnvironmentsObjs.push(
            {
              name: e,
              account: e,
              users: this.selectedUserlist.map(user => user.id),
              roles: selectedRoles,
              exclusions: {
                permissions: [],
                permission_groups: [],
                role: []
              },
              audit_logs: [
                {
                  action: 'CREATE',
                  by: shortName[shortName.length - 1],
                  at: Date.now()
                }
              ]
            }
        );
      }

      const payload = {
        partner: shortName[shortName.length - 1],
        name: this.groupName,
        description: this.description,
        display_name: this.groupName,
        environments: this.selectedEnvironmentsObjs,
        created_at: Date.now(),
        last_updated_at: Date.now(),
        created_by: shortName[shortName.length - 1],
        last_updated_by: shortName[shortName.length - 1]
      };

      this._service.addItem(payload, 'v1', environment.accessPartner, environment.accessPartner, 'usergroups').subscribe(res => {
        if (res) {
          for (const user_id of this.selectedUserlist.map(user => user.id)) {
            this._service.getItemswithParameter('v1', environment.accessPartner, environment.accessPartner, 'users', 'id=' + user_id).subscribe(resp => {
              if (resp) {
                const user = resp;

                user[0]['user_groups'].push(res['upsertedId']);
                this._service.patchItemUpdate(user[0]['id'], {'user_groups': user[0]['user_groups']}, 'v1', environment.accessPartner, environment.accessPartner, 'users').subscribe(updateRes => {
                  this.platform.openSnackBar('User Group created', 'Success', {
                    duration: 2000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                  });
                  loaderDialog.close();
                  this.dialogRef.close('success');
                });
              }
            });
          }
        }
      });
    } else {
      this.platform.openSnackBar('Group already exist', 'Error', {
        duration: 2000,
        verticalPosition: 'top',
        horizontalPosition: 'center'
      });
    }
  }

  createRoleForEachEnvironment(roleDetail) {
    return new Promise((resolve, reject) => {
      this._service.addItem(roleDetail, 'v1', environment.accessPartner, environment.accessPartner, 'roles').subscribe(data => {
        if (data) {
          resolve(data['upsertedId']);
        } else {
          resolve('failed');
        }
      }, error => {
        this.platform.notifyErrorToAdmins({error: 'Error occurred while creating role for the user ' + roleDetail['role']}, 'role_create_success', 'role_create_failed', 'Error occurred while creating role for the user ' + roleDetail['role'], roleDetail);
        resolve('failed');
      });
    });
  }

  removeUser(element: any) {
    const index = this.selectedUserlist.indexOf(element);
    if (index >= 0) {
      this.selectedUserlist.splice(index, 1);
    }
  }

  removeRole(element: any) {
    const index = this.selectedRolelist.indexOf(element);
    if (index >= 0) {
      this.selectedRolelist.splice(index, 1);
    }
  }

  removeEnvironment(element: any) {
    const index = this.selectedEnvironments.indexOf(element);
    if (index >= 0) {
      this.selectedEnvironments.splice(index, 1);
    }
  }

  ngOnInit() {
    this.partnerName = localStorage.getItem('partner');
    if (this.data['roles']) {
      this.rolesList = this.data['roles'];
    } else {
      this.getRoles();
    }
    if (this.data['users']) {
      for (const user of this.data['users']) {
        const shortname = user['user'].split('-');
        if (shortname[0] !== 'admin') {
          this.usersList.push(user);
        }
      }
    } else {
      this.getUsers();
    }
    if (this.data['groups']) {
      this.userGroups = this.data['groups'];
    } else {
      this.getGroups();
    }

    this.environmentList = this.data['environments'];
  }

}
